import { Box, Flex, Heading,  Image,  Span,  } from '@chakra-ui/react'
import React from 'react'
import { useColorModeValue } from '../../../components/ui/color-mode'
import { motion } from 'framer-motion'
import { useTranslation } from 'react-i18next'

const MotionFlex = motion.create(Flex)
const MotionImage = motion.create(Image)

const OurCollaborations = () => {

    const workflowArray = [
        {
            title: 'Miss Black & pretty',
            //description: 'Aplication web de vote en ligne Sass',
            image: require('../../../assets/Collaborateur/black-and-pretty.png'),
            isAvalaible: true,
            createdAt: '2024',
            isCurrent: true,
            link: ''
        },
        {
            title: 'Camer Diaspo Awards',
            //description: 'Aplication de lecture de Music en ligne',
            image: require('../../../assets/Collaborateur/camer-diaspo-awards.png'),
            isAvalaible: true,
            createdAt: '2022',
            isCurrent: false,
            link: 'https://template-music-website.vercel.app/'
        },
        {
            title: 'Miss Élégance Intercontinentale',
            //description: 'Site web boite de consulting',
            image: require('../../../assets/Collaborateur/elegance.png'),
            isAvalaible: true,
            createdAt: '2022',
            isCurrent: false,
            link: 'https://kbs-website-mu.vercel.app/'
        },
        {
            title: 'Miss Flambeau d’Afrique',
            //description: 'Aplication web de billetterie en ligne',
            image: require('../../../assets/Collaborateur/flambeau.png'),
            isAvalaible: true,
            createdAt: '2022',
            isCurrent: false,
            link: 'https://ongoo.net/'
        },
        {
            title: 'Miss Fomaric',
            //description: 'Aplication web de Vente et de Livraison',
            image: require('../../../assets/Collaborateur/fomaric.png'),
            isAvalaible: true,
            createdAt: '2022',
            isCurrent: false,
            link: 'https://randel-business-entreprise.onrender.com/'
        },
        {
            title: 'Miss Médias',
            //description: 'Application mobile de recherche d\'emploie au canada',
            image: require('../../../assets/Collaborateur/medias.png'),
            isAvalaible: false,
            createdAt: '2022',
            isCurrent: false,
            link: ''
        },
        {
            title: 'Miss Mums & Glam Africa',
            //description: 'Projet de fin de cycle Administration de systeme academique',
            image: require('../../../assets/Collaborateur/mum-and-glam.png'),
            isAvalaible: false,
            createdAt: '2022',
            isCurrent: false,
            link: 'https://ongoo.net/'
        },
         {
             title: 'House Of challenge',
             //description: 'Application de gestion de Finances',
             image: require('../../../assets/Collaborateur/hoc.png'),
             isAvalaible: true,
             alt: 'house of challenge',
             createdAt: '2026',
             isCurrent: false,
             //link: 'https://rainbow-qpdv.onrender.com/dashboard'
         },

        // {
        //     title: 'Miss Ronde & Belle Cameroun',
        //     //description: 'Application de gestion de Finances',
        //     image: require('../../../assets/Collaborateur/ronde-et-belle.png'),
        //     isAvalaible: true,
        //     createdAt: '2022',
        //     isCurrent: false,
        //     link: 'https://rainbow-qpdv.onrender.com/dashboard'
        // },
        {
            title: 'Miss Santé Cameroun',
            //description: 'Application de gestion de Finances',
            image: require('../../../assets/Collaborateur/sante.png'),
            isAvalaible: true,
            createdAt: '2022',
            isCurrent: false,
            link: 'https://rainbow-qpdv.onrender.com/dashboard'
        },
        {
            title: 'The Public Vision Awards',
            //description: 'Application de gestion de Finances',
            image: require('../../../assets/Collaborateur/tpva.png'),
            isAvalaible: true,
            createdAt: '2022',
            isCurrent: false,
            link: 'https://rainbow-qpdv.onrender.com/dashboard'
        },
        {
            title: 'Miss & Mister Universités Cameroun',
            //description: 'Application de gestion de Finances',
            image: require('../../../assets/Collaborateur/universites.png'),
            isAvalaible: true,
            createdAt: '2022',
            isCurrent: false,
            link: 'https://rainbow-qpdv.onrender.com/dashboard'
        },
    ]

    const filterVariable = useColorModeValue('grayscale(100%)', 'grayscale(100%)')
    const {t} = useTranslation()

    return (
        <Flex
            px={{ md: '10%', '2xl': "19%", base: 4 }}
            py={{'2xl' :40, base: 10}}
            overflow={'hidden'}
            position={'relative'}
            id='our-collaborations'
        >
            <Box w={'full'}>
                <Heading fontSize={{ '2xl': 'xl', md: 'xl', base: 'md' }} textAlign={'center'} fontFamily={'Outfit'} textTransform={'uppercase'}>
                    {t('collaborationTitle')}
                </Heading>
                <Heading
                    mt={{'2xl': 8, base: 2}}
                    textAlign={'center'}
                    fontWeight={600}
                    letterSpacing={-1.8}
                    fontFamily={'Poppins'}
                    fontSize={{ '2xl': '7xl', md: '3xl', base: '2xl' }}
                    lineHeight={1.2}
                ><Span bgGradient={'to-r'}
                    gradientFrom={'blue.500'}
                    gradientTo={'purple.600'}
                    bgClip={'text'}

                >{t('collaborationSubtitle').split(' ').slice(0, 1).join(' ')}</Span> {t('collaborationSubtitle').split(' ').slice(1).join(' ')}</Heading>



                <Box position="relative" w="full" overflow="hidden" mt={24}>
                    <Box
                        position="absolute"
                        left={0}
                        top={0}
                        bottom={0}
                        w="150px"
                        zIndex={2}
                        bgGradient="to-r"
                        gradientFrom={useColorModeValue('white', 'black')}
                        gradientTo="transparent"
                        pointerEvents="none"
                    />
                    <Box
                        position="absolute"
                        right={0}
                        top={0}
                        bottom={0}
                        w="150px"
                        zIndex={2}
                        bgGradient="to-l"
                        gradientFrom={useColorModeValue('white', 'black')}
                        gradientTo="transparent"
                        pointerEvents="none"
                    />
                    <MotionFlex
                        gap={16}
                        w={'max-content'}
                        animate={{ x: ["0%", "-50%"] }}
                        transition={{
                            x: {
                                repeat: Infinity,
                                repeatType: "loop",
                                duration: 30, // Adjust speed here (seconds)
                                ease: "linear",
                            },
                        }}
                    >
                        {
                            [...workflowArray, ...workflowArray].map((elt, index) =>
                                <Flex key={index} w={'150px'} flexShrink={0} justify={'center'} align={'center'}>
                                    <Image
                                        filter={filterVariable}
                                        src={elt.image}
                                        w={'120px'}
                                        alt={elt.alt}
                                        objectFit={'contain'}
                                        opacity={0.7}
                                        transition={'all 0.3s'}
                                        _hover={{
                                            filter: 'grayscale(0%)',
                                            opacity: 1,
                                            transform: 'scale(1.1)'
                                        }}
                                    />
                                </Flex>
                            )
                        }
                    </MotionFlex>
                </Box>



            </Box>




            {/* <Box w={'300px'} opacity={0.7} top={10} right={-100} filter={useColorModeValue('blur(10px)', 'none')}  transform={'scaleX(-1)'} position={'absolute'}>
            <svg  viewBox="0 0 260 222" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M75 30C108.137 30 135 56.8629 135 90C135 123.137 108.137 150 75 150C41.8629 150 15 123.137 15 90C15 56.8629 41.8629 30 75 30Z" stroke="#c836c3" strokeWidth="30"/>
                <circle cx="240" cy="20" r="20" fill="#1e8af0ff"/>
                <circle cx="230" cy="192" r="27.5" stroke="#248fdcff" strokeWidth="5"/>
            </svg>
        </Box> */}

            <MotionImage
                w={{ '2xl': '400px', base: '200px'}}
                opacity={useColorModeValue(0.5, 0.8)}
                rotate={'-35deg'}
                top={{'2xl': 10, base: -8}}
                right={{'2xl': -100, base: '-32%'}}
                position={'absolute'}
                src={require('../../../assets/vector/5.png')}
                // initial={{ opacity: 0, x: 50 }}
                // whileInView={{ opacity: useColorModeValue(0.5, 0.8), x: 0 }}
                // animate={{ y: [0, -20, 0] }}
                // transition={{
                //     duration: 1,
                //     y: { duration: 6, repeat: Infinity, ease: "easeInOut" }
                // }}
            />




        </Flex>
    )
}

export default OurCollaborations